@if (showFreeDeliveryText()()) {
  <div
    class="buy-more-free-shipping font-serif" i18n>
    Du mangler kun at købe for
    <span class="text-orange">{{ untilFreeDelivery(cart())|currency }} {{ currencyCode() }}</span>
    for at få gratis fragt
  </div>
}
